<div class="dialog-content-wrapper">

    <mat-toolbar matDialogTitle class="accent m-0" fxFlex="1 0 auto" fxLayout="row">

        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span>{{data.formTitle | translate}}</span>
            <button mat-icon-button (click)="closeDialog()" aria-label="Close Dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>

    </mat-toolbar>


    <div mat-dialog-content class="py-24 px-0 m-0">
        <p-toast key="msgs" [showTransformOptions]="'translateX(100%)'"></p-toast>
        <form name="simpleDialogForm" id="simpleDialogForm" #simpleDialogForm="ngForm" class="w-100-p" fxLayout="column"
            fxFlex>
            <div class="p-24" fusePerfectScrollbar>

                <mat-form-field appearance="outline" class="w-100-p">
                    <mat-label>{{'App.SIMPLE_DIALOG.NAME' | translate}}</mat-label>
                    <input matInput [(ngModel)]="object.name" #name id="name" name="name" required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100-p">
                    <mat-label>{{'App.SIMPLE_DIALOG.DESCRIPTION' | translate}}</mat-label>
                    <textarea matInput [(ngModel)]="object.description" #description id="description"
                        name="description" [required]="data.descriptionRequired" rows="5">
                        </textarea>
                </mat-form-field>

            </div>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button mat-raised-button id="btn-cancel" class="red mr-8" (click)="closeDialog()">
            {{'App.CANCEL' | translate}}
        </button>

        <button id="btn-add" mat-button class="blue-grey" *ngIf="data.addingNew" (click)="onSubmit(simpleDialogForm,true)">
            <span>{{'App.ADD_CREATE' | translate}}</span>
        </button>

        <button id="btn-save" mat-button class="light-green fuse-white-fg" 
            (click)="onSubmit(simpleDialogForm)">
            <span>{{'App.SAVE' | translate}}</span>
        </button>

    </div>

</div>